function isValidMaskedCpf(value) {
    return value.length === 11 && value.includes('*');
}
export function isValidCpf(cpf) {
    if (isValidMaskedCpf(cpf)) {
        return true;
    }
    const cleaned = cpf.replace(/\D/g, '');
    if (cleaned.length !== 11 || /^([0-9])\1+$/.test(cleaned))
        return false;
    let sum = 0;
    for (let i = 0; i < 9; i++)
        sum += parseInt(cleaned.charAt(i)) * (10 - i);
    let rev = 11 - (sum % 11);
    if (rev === 10 || rev === 11)
        rev = 0;
    if (rev !== parseInt(cleaned.charAt(9)))
        return false;
    sum = 0;
    for (let i = 0; i < 10; i++)
        sum += parseInt(cleaned.charAt(i)) * (11 - i);
    rev = 11 - (sum % 11);
    if (rev === 10 || rev === 11)
        rev = 0;
    if (rev !== parseInt(cleaned.charAt(10)))
        return false;
    return true;
}
